import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Environment, EnvironmentConfigService, PlatformServiceName } from '../environment';
import { UserService } from '../user';
import * as i0 from "@angular/core";
import * as i1 from "../../../../model/src/lib/environment.token";
import * as i2 from "../environment/environment-config.service";
import * as i3 from "../user/user.service";
import * as i4 from "@angular/common/http";
export class ReportService {
    constructor(environment, environmentConfigService, userService, http) {
        this.userService = userService;
        this.http = http;
        this.apiUrl =
            environmentConfigService.getEnvironmentConfigs().apis.platform.url +
                '/' +
                environment.serviceUrlList[PlatformServiceName.ReportingService];
    }
    getDistanceByJurisdictionReports(startDate, endDate, jurisdictions, vehicles) {
        const businessAccountId = this.userService.getBusinessAccount();
        const request = {
            businessAccountId: { value: businessAccountId },
            startDate,
            endDate,
            jurisdictions,
            vehicles
        };
        return this.http
            .post(`${this.apiUrl}/distance-by-jurisdiction-reports:search`, request)
            .pipe(map((response) => {
            return response.report;
        }));
    }
}
ReportService.ngInjectableDef = i0.defineInjectable({ factory: function ReportService_Factory() { return new ReportService(i0.inject(i1.ENVIRONMENT), i0.inject(i2.EnvironmentConfigService), i0.inject(i3.UserService), i0.inject(i4.HttpClient)); }, token: ReportService, providedIn: "root" });
